var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useEffect } from 'react';
import RootSiblings, { RootSiblingPortal } from 'react-native-root-siblings';
import { useLockScroll } from '../../hooks/useLockScroll';
/**
 * 包装组件，支持方法的方式调用
 */
export function wrap(Children) {
    return (props) => {
        const { onClose } = props;
        let close = null;
        const modal = new RootSiblings((React.createElement(Children, Object.assign({ ref: (r) => {
                if (r && r.close) {
                    close = r.close;
                }
            } }, props, { onClose: () => {
                if (onClose) {
                    onClose();
                }
                else if (close) {
                    close();
                }
            }, onAnimatedEnd: () => {
                modal.destroy();
            } }))));
        return {
            close: () => {
                close && close();
            },
        };
    };
}
function usePrevious(data) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = data;
    }, [data]);
    return ref.current;
}
/**
 * 包装组件，支持组件的方式调用
 */
export function wrapFC(Children) {
    return function (props) {
        const { visible = false } = props, rest = __rest(props, ["visible"]);
        // 为了保证组件的动画，内部需要单独控制组件的展示和隐藏
        const [control, setControl] = useState(visible);
        const ref = useRef(null);
        const { lock, unlock } = useLockScroll(visible);
        const prevControl = usePrevious(control);
        useEffect(() => {
            if (!visible && control) {
                ref.current && ref.current.close();
            }
            else if (visible) {
                setControl(true);
            }
        }, [visible]);
        useEffect(() => {
            if (props.lockScroll && control) {
                lock();
            }
            else if (props.lockScroll && !control && prevControl) {
                unlock();
            }
            return () => {
                //更新时先执行，卸载时只执行
                if (props.lockScroll && control && prevControl === undefined) {
                    unlock();
                }
            };
        }, [control]);
        if (!control) {
            return null;
        }
        return (React.createElement(RootSiblingPortal, null,
            React.createElement(Children, Object.assign({}, rest, { ref: ref, onAnimatedEnd: () => {
                    setControl(false);
                } }))));
    };
}
